import { PermissionEnum } from '../../../common/permissions/permissions.Enum';
import { getGroupPermissionFactory } from '../../../common/permissions/permissions.utils';
import { AccountsPermissions } from './accounts.permissions';

export class AccountsSpecializedRolesPermissions {
    static GroupName = `${AccountsPermissions.GroupName}.SpecializedRoles`;

    static getPermissions = getGroupPermissionFactory(AccountsSpecializedRolesPermissions.GroupName);

    static Permissions = {
        Create: AccountsSpecializedRolesPermissions.getPermissions(PermissionEnum.CREATE),
        Read: AccountsSpecializedRolesPermissions.getPermissions(PermissionEnum.READ),
        ReadAll: AccountsSpecializedRolesPermissions.getPermissions(PermissionEnum.READ_ALL),
        Update: AccountsSpecializedRolesPermissions.getPermissions(PermissionEnum.UPDATE)
    };
}
